import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminPermission } from '../hooks/useAdminPermission';

interface AdminRouteGuardProps {
  children: React.ReactNode;
  /** Optional path override for permission check */
  path?: string;
}

/**
 * Secondary gate after AdminPrivateRoute — hides routes the admin role cannot access.
 */
const AdminRouteGuard: React.FC<AdminRouteGuardProps> = ({ children, path }) => {
  const location = useLocation();
  const { canAccessRoute } = useAdminPermission();
  const target = path || location.pathname;

  if (!canAccessRoute(target)) {
    return <Navigate to="/admin/dashboard" replace state={{ forbidden: target }} />;
  }

  return <>{children}</>;
};

export default AdminRouteGuard;
